module.exports = __webpack_public_path__ + "static/c_8-689e3c0a7ae9b3014f98d6d7085310a2.jpg";